import { Route, Router, useLocation, useParams } from "wouter";
import AdminApp from "./admin/AdminApp";
import "./App.css";
import UserApp from "./user/UserApp";
import { ConfigProvider } from "antd";
import { memo, useEffect } from "react";
import {
  startVersionCheck,
  refreshPage,
  storeVersion,
} from "./utilities/versionChecker";

function App() {
  const [location] = useLocation();
  const isAdmin = location.startsWith("/admin");
  const params = new URLSearchParams(window.location.search);
  const source = params.get("source");
  useEffect(() => {
    const stopCheck = startVersionCheck((newVersion, oldVersion) => {
      console.log(
        `New version detected: ${oldVersion} → ${newVersion}. Refreshing...`,
      );
      refreshPage();
    });

    // Store the current version
    const storeCurrentVersion = async () => {
      try {
        const currentVersion = await (
          await fetch(
            `${window.location.origin}/version.json?t=${Date.now()}`,
            {
              cache: "no-store",
              headers: { "Cache-Control": "no-cache" },
            },
          )
        ).json();
        storeVersion(currentVersion.version);
      } catch (error) {
        console.error("Error storing current version:", error);
      }
    };
    storeCurrentVersion();

    // Redirection to App Store/Play Store for mobile users
    if (!isAdmin && source === "whatsapp") {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // Android redirection
      if (/android/i.test(userAgent)) {
        window.location.href =
          "https://play.google.com/store/apps/details?id=com.hks.alpdms&pcampaignid=web_share";
      }
      // iOS redirection
      else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        window.location.href =
          "https://apps.apple.com/in/app/alp-dms/id6755678578";
      }
    }

    // Cleanup on unmount
    return () => stopCheck();
  }, [isAdmin]);

  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: "rgb(4, 116, 184)",
          borderRadius: 2,
          // colorBgContainer: "#f6ffed",
        },
      }}
    >
      <div className="App">
        <Router>
          {isAdmin ? (
            <>
              <Route path="/admin" component={AdminApp} />
              <Route path="/admin/*" component={AdminApp} />
            </>
          ) : (
            <Route path="/*" component={UserApp} />
          )}
        </Router>
      </div>
    </ConfigProvider>
  );
}

export default memo(App);
